var symphony = symphony || {};

;
(function () {

    symphony.locationSearchUrlSet = false;
    symphony.registerEvents = function () {

        $('a[href*="#whatwedo"]').click(function (e) {
            if ($('#what-we-do').length > 0) {
                e.preventDefault();
                e.stopPropagation();
                symphony.site.animateScrollTo($('#what-we-do'));
            }
        });

        if (window.location.hash == "#whatwedo" && $('#what-we-do').length > 0) {
            symphony.site.animateScrollTo($('#what-we-do'));
        }


        $('h2:contains("Search Again")').text('Location Search').addClass('gdos-heading');

        function setLocationSearchUrl(timesRun) {
            timesRun = timesRun || 1;
            if (window.localStorage && window.localStorage.getItem('gdoscentersearchquery')) {
                if (window.localStorage.getItem('gdoscentersearchlat') && window.localStorage.getItem('gdoscentersearchlng')) {
                    $('#gdosCenterSearch-link').attr('href', fullSiteDomain + '/plugins/gdosCenterSearch?mode=query_2&lat=' + JSON.parse(window.localStorage.getItem('gdoscentersearchlat')) + '&lng=' + JSON.parse(window.localStorage.getItem('gdoscentersearchlng')) + '&code=US&query=' + JSON.parse(window.localStorage.getItem('gdoscentersearchquery')) + '&mode=query_1&limit=40');
                    symphony.locationSearchUrlSet = true;
                } else {
                    $('#gdosCenterSearch-link').attr('href', fullSiteDomain + '/plugins/gdosCenterSearch?query=' + JSON.parse(window.localStorage.getItem('gdoscentersearchquery')) + '&mode=query_1&limit=40');
                }
            }
            setQaUrls();

            //make sure the localStorage vaiiables have time to set when the page loads
            if (!symphony.locationSearchUrlSet && timesRun < 10) {
                setTimeout(function () {
                    setLocationSearchUrl(timesRun + 1);
                }, 1000);
            }
        }

        function setQaUrls() {
            if (window.location.hostname.indexOf('mdqa.') > -1 || window.location.hostname == 'md1' || window.location.hostname == 'md0' || window.location.hostname == 'staging.sal.lnx1.chltest.com') {
                $('a[href^="' + fullSiteDomain + '"]').each(function () {
                    if ($(this).attr('href')) {
                        $(this).attr('href', $(this).attr('href').replace(fullSiteDomain, window.location.protocol + '//' + window.location.hostname + '/' + siteUrlAlias));
                    }
                });
            }
        }

        if ($('#TextBoxPostcode').is(':visible') && UTIL.GetQueryStringParameterByName('start') != '1') {
            setLocationSearchUrl();
        }

        if ($('.admin-body').length == 0) {
            setQaUrls();
        }

    };


})();
